import { locale as LocaleService } from "../../../services/LocaleService.js";

export const ReferralSection = (inviteLink, referralCount, rewardAmount = 500) => {
    // Dynamic reward display (reads from Firestore via WalletTab)
    const rewardBadge = `${LocaleService.t('mypage.invite_reward_prefix') || '보상'} +${rewardAmount}P`;
    const rewardDesc = (LocaleService.t('mypage.invite_desc_template') || '친구에게 초대 링크를 공유하세요. 두 분 모두에게 {amount}P를 드립니다!').replace('{amount}', rewardAmount);

    const html = `
        <div class="bg-white border border-gray-200 rounded-xl p-5 shadow-sm">
            <div class="flex items-center justify-between mb-4">
                <h3 class="font-bold text-gray-900 flex items-center gap-2">
                    <span class="material-symbols-outlined text-green-500">group_add</span> ${LocaleService.t('mypage.invite_title')}
                </h3>
                <span class="bg-green-50 text-green-600 text-xs font-bold px-2 py-1 rounded">${rewardBadge}</span>
            </div>
            
            <p class="text-sm text-gray-500 mb-4">${rewardDesc}</p>

            <div class="flex items-center gap-2 mb-2">
                <div class="flex-1 bg-gray-50 border border-gray-200 rounded-lg px-3 py-2 text-sm text-gray-600 font-mono truncate select-all" id="ref-link-box">
                    ${inviteLink}
                </div>
                <button id="btn-copy-ref" class="bg-gray-900 text-white px-4 py-2 rounded-lg font-bold text-sm hover:bg-black transition-colors whitespace-nowrap">
                    ${LocaleService.t('common.copy')}
                </button>
            </div>
            
            <div class="mt-4 pt-4 border-t border-gray-100 flex justify-between items-center text-sm">
                <span class="text-gray-500">${LocaleService.t('mypage.invited_count')}</span>
                <span class="font-bold text-gray-900">${referralCount}${LocaleService.t('mypage.unit_people')}</span>
            </div>
        </div>
    `;

    // Helper to bind events after render. Returns a function to be called with the rendered element/parent.
    const bindEvents = (parent) => {
        const btnCopy = parent.querySelector('#btn-copy-ref');
        if (btnCopy) {
            btnCopy.onclick = () => {
                navigator.clipboard.writeText(inviteLink).then(() => {
                    const original = btnCopy.innerHTML;
                    btnCopy.innerHTML = '<span class="material-symbols-outlined text-sm">check</span>';
                    setTimeout(() => btnCopy.innerHTML = original, 2000);
                });
            };
        }
    };

    return { html, bindEvents };
};
